<template>
  <div class="page-header">
    <!-- <v-btn variant="text" class="back-btn" @click="handleBack">
      <v-icon size="25">mdi-chevron-left</v-icon>
      BACK
    </v-btn> -->
    <h2 class="page-title">{{ title }}</h2>
    <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

const props = defineProps<{ title: string; subtitle?: string }>();
const router = useRouter();

function handleBack() {
  if (window.history.length > 1) {
    router.back();
    return;
  }
  router.push({ name: "vendor.dashboard" });
}
</script>

<style scoped>
.page-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.back-btn {
  align-self: flex-start;
  border: 0;
  background: transparent;
  color: #f97316;
  /* font-size: var(--font-size-default); */
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
}

.page-title {
  margin: 0;
  font-size: 18px;
  color: #0f172a;
}

.page-subtitle {
  margin: 0;
  font-size: 14px;
  color: #64748b;
}
</style>
